<template>
    <div :style="[filterOverride]" :class="['filters filter-modal topHeadingLayout', { open: modalOpen }]">
        <div class="inner-wrapper" v-if="showFilterFlyout">
            <span class="header-links reset" v-show="filtersActive.length" @click="clearAllFilters()">
                {{ $t('results.filtering.resetAll') }}
            </span>

            <div class="top-heading">
                <slot name="heading"></slot>
            </div>

            <div class="close" @click="closeModal()">
                <slot name="headerContent"></slot>
            </div>

            <div class="container filter-content">
                <slot name="content" :close="closeModal"></slot>
            </div>
        </div>

        <slot name="footerContent" :clearAllFilters="clearAllFilters"></slot>
    </div>

    <div class="modal-overlay d-none" :class="{ 'd-lg-block': modalOverlay }"></div>
</template>

<script>
import some from 'lodash/some'
import split from 'lodash/split'
import toNumber from 'lodash/toNumber'
import { mapGetters } from 'vuex'

export default {
    props: {
        modalOpen: false,
    },
    data() {
        return {
            filterOverride: {},
            topOffset: null,
            iframeAllowedSites: [],
            modalOverlay: false,
        }
    },
    mounted() {
        this.emitter.on('openFilterModal', this.openModal)

        if (window.IS_IFRAME) {
            this.filterOverride.display = 'none'
        }

        this.iframeAllowedSites = this.themeSetting('iframe_allowed_sites')

        window.addEventListener(
            'message',
            event => {
                const messageContent = event.data

                if (some(this.iframeAllowedSites, ['name', event.origin])) {
                    if (window.innerWidth < 995) {
                        const stickyTool = document.querySelector('.quick-sticky-tool')
                        const stickyToolHeight = stickyTool.offsetHeight
                        const variables = split(messageContent, '|')
                        const modalOffset = variables[1]
                        const windowHeight = variables[2]
                        const iframeOffsetBottom = variables[3]
                        const iframeOffsetTop = variables[5]
                        let topOffset = toNumber(modalOffset) + toNumber(windowHeight)

                        if (topOffset + stickyToolHeight + toNumber(iframeOffsetTop) > toNumber(iframeOffsetBottom)) {
                            topOffset = toNumber(iframeOffsetBottom) - toNumber(iframeOffsetTop)
                        }

                        topOffset = `${topOffset - (75 + stickyToolHeight)}px`

                        this.filterOverride.position = 'absolute'
                        this.filterOverride.height = windowHeight + 'px'
                        this.filterOverride.overflow = 'scroll'

                        if (this.modalOpen || this.modalSortOpen) {
                            this.filterOverride.top = `${modalOffset - 50}px`
                        }
                    } else {
                        this.filterOverride = {}
                    }
                }
            },
            false,
        )
    },
    computed: {
        ...mapGetters(['filtersActive', 'filtersModified']),
        showFilterFlyout: function () {
            return this.themeSetting('hide_product_type_filter') !== true
        },
    },
    methods: {
        clearAllFilters() {
            this.$store.commit('clearAllFilters')
        },
        saveAllFilters() {
            this.$store.commit('saveAllFilters')
        },
        openModal: function () {
            if (window.IS_IFRAME) {
                this.filterOverride.display = 'flex'
                if (window.innerWidth >= 995) {
                    this.filterOverride.top = '400px'
                }
            }

            this.modalOverlay = true
        },
        closeModal: function () {
            if (this.filtersModified.length) {
                this.saveAllFilters()
            }

            if (window.IS_IFRAME) {
                this.filterOverride.display = 'none'
            }

            this.emitter.emit('closeFilterModal')
            this.emitter.emit('closeHeroModal')
            this.modalOverlay = false
        },
    },
    watch: {
        modalOpen() {
            if (this.modalOpen) {
                this.openModal()
            } else {
                this.closeModal()
            }
        },
    },
}
</script>

<style scoped lang="scss">
@import '~scss/mixins/rem';

.filters {
    display: flex;
    align-items: baseline;
    flex-grow: 1;
    margin-right: 36px;

    .clear-filters {
        font-size: rem(14px);
        margin-left: 10px;
        cursor: pointer;
        user-select: none;

        .fa-times {
            position: relative;
            top: 1px;
            font-size: 15px;
            margin-right: 4px;
        }
    }
}

.modal-overlay {
    background: rgba(0, 0, 0, 0.6);
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
}
</style>
